import { getAssigneeResources, queryAssigneeResources, updateIssue, getIssueSelectOptions } from '@/api/resource';
import dayjs from 'dayjs';
import { isNil, groupBy, cloneDeep, range, minBy, maxBy } from 'lodash';
import i18n from 'common-module/src/lang';

const addDays = 60;
const addWeeks = 126;
const addMonths = 20;
const state = {
  scrollTop: 0, // 同步左右滚动条
  scrollLeft: 0,
  dayCellWidth: 160, // 一天对应的宽度
  selectType: 'day', //选择天周还是月
  issueDetailData: {}, //获取详情信息
  filterOptions: {}, // 过滤条件下拉选项
  dateRange: [], // 开始结束日期
  dateList: [], // 表头日期列表
  headerDateVOS: [], //后端返回的处理数据
  originHeaderDateVOS: [], //后端返回的原子数据
  actionRecord: {}, // issue列表内容高度等
  expands: new Set(),
  filterView: 'estimatePoint',
  showStatusColor: true,
  showMergeSubtask: false,
  showWeekend: true,
  filter: {},
  colorData: {
    dept: {
      shallow: '#C5E3FF',
      deep: '#5CA4F7'
    },
    assignee: {
      shallow: '#E5F7E6',
      deep: '#8ADFBE'
    }
  },
  selectOption: {},
  isExpandAll: false,
  startEndIndex: [],
  issueMap: {},
  list: [],
  assigneeIssue: {},
  assigneeOriginIssue: {},
  assigneeResources: {},
  unDeptAssigneeVOS: {},
  dragTeamIssueAreaId: ''
};

const getters = {
  isExpand(state) {
    return key => {
      // console.log(9996666, state.expands);
      return state.expands.has(key);
    };
  },
  isSelectDay(state) {
    return state.selectType === 'day';
  },
  getFormatEstimateManHour(state) {
    return function (value) {
      if (isNil(value)) {
        return value;
      }
      if (state.filterView === 'manHour') {
        if (value === 0) {
          return '0h';
        }
        let str = '';
        const h = Math.floor(value / 3600);
        const m = Math.floor((value % 3600 / 60));
        if (h > 0) {
          str += `${h}h`;
        }
        if (m > 0) {
          str += `${m}m`;
        }
        return str;
      }
      if (state.filterView === 'estimatePoint' || state.filterView === 'issueCount') {
        if (((value + '').indexOf('.') !== -1)) {
          return value.toFixed(1);
        }
        return value;
      }
    };
  },
  //点数下拉选项
  estimatePointOptions(state) {
    return function ({ projectId, issueTypeId }) {
      const options = state.selectOption[`projectId_${projectId}_issueTypeId_${issueTypeId}`];
      if (!options?.length) {
        return [];
      }
      return options.find(item => item.fieldCode === 'estimatePoint')?.optionVOList || [];
    };
  },
  // 是否展开所有
  isDeptExpandAll(state) {
    return function (deptId) {
      if (!state.expands.has(`dept_${deptId}`)) {
        return false;
      }
      const { deptVOS: deptList = [] } = state.assigneeResources;
      const dept = deptList.find(item => item.deptId === deptId);
      if (!dept) {
        return false;
      }
      return dept.assigneeVOS.every(
        assignee => state.expands.has(`assignee_${deptId}_${assignee.assigneeId}`)
      );
    };
  },
  // 展示的平铺团队列表
  virtualList(state) {
    // console.log(7752, state.assigneeIssue);
    const virtualList = state.list.filter(
      item => {
        if (item.uid === 'unAssignee' && !(!state.filter?.assignee?.length || state.filter?.assignee?.includes('UnAssignee'))) {
          return false;
        }
        return item.level === 0 || state.expands.has(item.parentUid);
      }
    );
    [...state.expands].forEach(
      uid => {
        if (uid === 'unAssignee' && !(!state.filter?.assignee?.length || state.filter?.assignee?.includes('UnAssignee'))) {
          return;
        }
        // console.log('🚀 ~ file: resource.js ~ line 117 ~ virtualList ~ uid', uid);
        const parts = uid.split('_');
        const key = parts.length === 3 ? `assignee_${parts[2]}` : uid === 'unAssignee' ? 'unAssignee' : `assignee_${parts[1]}`;
        const index = virtualList.findIndex(item => item.uid === uid);
        if (index !== -1) {
          if (key && state.assigneeIssue[key]?.length) {
            const assigneeIssueList = state.assigneeIssue[key].map((item, issueIndex) => {
              const issueRowUid = `issue.${uid}.${issueIndex + 1}`;
              return Object.freeze({ uid: issueRowUid, pathId: `${virtualList[index].pathId}.${item?.[0]?.id}`, path: item?.[0].path, height: 50, list: item, type: 'issue' });
            });
            virtualList.splice(index, 1, virtualList[index], ...assigneeIssueList);

          } else if (key && state.assigneeOriginIssue[key]) {

            const { issueVOS, issueType, assigneeId } = state.assigneeOriginIssue[key];
            const issues = newCalculateIssueList(issueVOS, state.issueMap, issueType, null, assigneeId);
            state.assigneeIssue[key] = Object.freeze(issues);
            const assigneeIssueList = state.assigneeIssue[key].map((item, issueIndex) => {
              const issueRowUid = `issue.${uid}.${issueIndex + 1}`;
              return Object.freeze({ uid: issueRowUid, pathId: `${virtualList[index].pathId}.${item?.[0]?.id}`, path: item?.[0].path, height: 50, list: item, type: 'issue' });
            });
            virtualList.splice(index, 1, virtualList[index], ...assigneeIssueList);
          }
        }
      }
    );
    // console.log(999999, virtualList);
    return Object.freeze(virtualList);
  },
  viewDateList(state) {
    const [startIndex, endIndex] = state.startEndIndex;
    return state.dateList.slice(startIndex, endIndex);
  },
  translateX(state) {
    const dateSum = state.selectType === 'day' ? state.dateList.slice(0, state.startEndIndex[0]).reduce((res, item) => {
      return res + item.width;
    }, 0) : state.startEndIndex[0] * state.dayCellWidth * (state.selectType === 'week' ? 7 : 30);
    return dateSum - state.scrollLeft;
  },
  dateRowWidth(state) {
    const weekSum = state.selectType === 'day' ? state.headerDateVOS.reduce((res, next) => {
      const weekDayNum = next.workday ? 0 : 0.5;
      return res + weekDayNum;
    }, 0) : 0;
    return (state.dateList.length - weekSum) * state.dayCellWidth;
  },
  //默认开始结束时间
  defaultStartEndDate(state) {
    const { defaultBeginTime, defaultEndTime } = state.assigneeResources;
    if (defaultBeginTime && defaultEndTime) {
      return [defaultBeginTime, defaultEndTime];
    }
    
    const _defaultBeginTime = dayjs().getTime();
    const _defaultEndTime = dayjs(_defaultBeginTime).add(30, 'day').getTime();
    return [_defaultBeginTime, _defaultEndTime];
  },
  // 用户行为记录
  habitRecord(state) {
    return state.assigneeResources?.customerHabitMap || {};
  },
  // 筛选条件
  filterOptions(state) {
    const { assigneeVOS, projectVOS, departmentVOS } = state.assigneeResources;
    return {
      assigneeVOS,
      projectVOS,
      departmentVOS
    };
  },
  deptVOS(state) {
    const { deptVOS } = state.assigneeResources;
    return deptVOS;
  },
  viewDateListNew(state) {
    const [startIndex, endIndex] = state.startEndIndex;
    const viewList = state.dateList.slice(startIndex * (state.selectType === 'week' ? 7 : 30), endIndex * (state.selectType === 'week' ? 7 : 30));
    return Object.entries(groupBy(viewList, `year_${state.selectType}`)).map(([k, v]) => {
      return { list: v, date: k, isGroup: true, width: v.length * state.dayCellWidth };
    });
  },
  dateListNew(state) {
    return Object.entries(groupBy(state.dateList, `year_${state.selectType}`)).map(([k, v]) => {
      return { list: v, date: k, isGroup: true, width: v.length * state.dayCellWidth };
    });
  }
};

const mutations = {
  SET_ASSIGNEE_RESOURCES(state, data) {
    state.assigneeResources = data;
    state.unDeptAssigneeVOS = (data.unDeptAssigneeIds || []).map(item => data?.assigneeDetailMap[item]);
  },
  SET_ISSUE_MAP(state, data) {
    state.issueMap = data;
  },
  SET_DRAG_TEAM_ISSUE_AREAID(state, data) {
    state.dragTeamIssueAreaId = data;
  },
  SET_SCROLLTOP(state, scrollTop) {
    state.scrollTop = scrollTop;
  },
  SET_SCROLLLEFT(state, scrollLeft) {
    state.scrollLeft = scrollLeft;
  },
  SET_RESET_ASSIGNEE_ISSUE(state, list) {
    const totalItems = {};
    Object.values(state.assigneeIssue).forEach(item => {
      item.flat().forEach(ele => {
        totalItems[ele.id] = ele;
      });
    });
    list.forEach(dataItem => {
      if (totalItems[dataItem.id]) {
        const newItem = { ...dataItem, ...dataItem.stateCategoryVO, assigneeId: dataItem.assignee?.id, isDetail: true };
        delete newItem.stateCategoryVO;
        const cathItem = { ...newItem };
        delete cathItem.isDetail;
        state.issueDetailData[dataItem.id] = cathItem;
        Object.assign(totalItems[dataItem.id], newItem);
      }
    });
    // console.log(88888888, list, state.assigneeIssue);
    state.assigneeIssue = cloneDeep(state.assigneeIssue);
  },
  CLEAR(state) {
    //state.dateList = [];
    state.dateRange = [];
    state.scrollTop = 0;
    state.scrollLeft = 0;
  },
  SET_ORIGINDATALIST(state, data) {
    state.originHeaderDateVOS = data;
  },
  SET_DATE(state, data) {
    let newData = data?.map(item => {
      const itemWidth = item.workday ? state.dayCellWidth : state.dayCellWidth / 2;
      return Object.freeze({
        ...item,
        width: itemWidth
      });
    }) || [];
    if (!state.showWeekend && state.selectType === 'day') {
      newData = newData.filter(item => item.workday);
    }
    let dateList = [...newData];
    const startDate = dateList[0]?.date || new Date();
    const endDate = dateList[dateList.length - 1]?.date || new Date();
    if (state.selectType === 'week') {
      const startDay = dayjs(startDate).day();
      const endDay = dayjs(endDate).day();
      if (startDay !== 1) {
        addItem(startDay - 1, dateList, startDate, false, state.dayCellWidth);
      }
      if (endDay !== 7) {
        addItem(7 - endDay, dateList, false, endDate, state.dayCellWidth);
      }
      const startDateNew = dateList[0]?.date || new Date();
      const endDateNew = dateList[dateList.length - 1]?.date || new Date();
      addItem(addWeeks, dateList, startDateNew, endDateNew, state.dayCellWidth);
      if (dayjs().isBefore(dayjs(dateList[0]?.date), 'day') || dayjs().isAfter(dayjs(dateList[dateList.length - 1]?.date), 'day')) {
        calDiffDays(dateList, state.dayCellWidth);
      }
      dateList = dateList.map(item => createDateItem(item));
    }
    if (state.selectType === 'month') {
      const startDateNum = dayjs(startDate).date();
      const endTotalDays = dayjs(endDate).daysInMonth();
      const endDateNum = dayjs(endDate).date();
      if (startDateNum !== 1) {
        addItem(startDateNum - 1, dateList, startDate, false, state.dayCellWidth);
      }
      if (endDateNum !== endTotalDays) {
        addItem(endTotalDays - endDateNum, dateList, false, endDate, state.dayCellWidth);
      }
      const startDateNew = dateList[0]?.date || new Date();
      const endDateNew = dateList[dateList.length - 1]?.date || new Date();
      addItemByMonth(addMonths, dateList, startDateNew, endDateNew, state.dayCellWidth);
      if (dayjs().isBefore(dayjs(dateList[0]?.date), 'day') || dayjs().isAfter(dayjs(dateList[dateList.length - 1]?.date), 'day')) {
        calDiffDays(dateList, state.dayCellWidth);
      }
      dateList = dateList.map(item => createDateItem(item));
    }
    if (state.selectType === 'day') {
      const startWeekendDays = getStartOrEndWeekend(data, false);
      const endWeekendDays = getStartOrEndWeekend(data, true);
      addItem(addDays, dateList, startDate, endDate, state.dayCellWidth, !state.showWeekend, startWeekendDays, endWeekendDays);
      if (dayjs().isBefore(dayjs(dateList[0]?.date), 'day') || dayjs().isAfter(dayjs(dateList[dateList.length - 1]?.date), 'day')) {
        calDiffDays(dateList, state.dayCellWidth, !state.showWeekend);
      }
    }
    if (!dayjs(state.dateRange[0]).isSame(dayjs(dateList[0].date), 'day') ||
      !dayjs(state.dateRange[1]).isSame(dayjs(dateList[dateList.length - 1].date, 'day'))) {
      state.dateRange = [dateList[0].date, dateList[dateList.length - 1].date];
    }
    // console.log(111111, newData, dateList);
    state.headerDateVOS = newData;
    state.dateList = Object.freeze(dateList) || [];
  },
  SET_DATE_RANGE(state, direction) {
    const startDate = state.dateList[0]?.date || new Date();
    const endDate = state.dateList[state.dateList.length - 1]?.date || new Date();
    const dateList = [...state.dateList];
    const addNum = state.selectType === 'day' ? 1 : (state.selectType === 'week' ? 7 : 30);
    if (direction === 'left') {
      for (let i = 0; i < addNum; i++) {
        dateList.unshift(createDateItem({
          date: dayjs(startDate).subtract(i + 1, 'days').format('YYYY-MM-DD'),
          noStatistics: true,
          width: state.dayCellWidth
        }));
        // dateList.pop();
      }
      state.dateList = Object.freeze(dateList);
      state.scrollLeft = 1;
    }
    if (direction === 'right') {
      for (let i = 0; i < addNum; i++) {
        dateList.push(createDateItem({
          date: dayjs(endDate).add(1 + i, 'days').format('YYYY-MM-DD'),
          noStatistics: true,
          width: state.dayCellWidth
        }));
        // dateList.shift();
      }
      state.dateList = Object.freeze(dateList);
      state.scrollLeft = state.scrollLeft - 2;
    }
  },
  SET_ACTION_RECORD(state, data) {
    state.actionRecord = {
      ...state.actionRecord,
      ...data
    };
  },
  SET_FILTER_VIEW(state, data) {
    state.filterView = data;
  },
  SET_SHOW_WEEKEND(state, data) {
    state.showWeekend = data;
  },
  SET_SHOW_STATUSCOLOR(state, data) {
    state.showStatusColor = data;
  },
  SET_SHOW_MERGESUBTASK(state, data) {
    state.showMergeSubtask = data;
  },
  SET_FILTER(state, data) {
    state.filter = data;
  },
  SET_SELECT_OPTIONS(state, data) {
    state.selectOption = {
      ...state.selectOption,
      ...data
    };
  },
  SET_EXPANDS(state, data) {
    state.expands = data || new Set();
  },
  SET_EXPAND(state, key) {
    if (!key) {
      return;
    }
    if (state.expands.has(key)) {
      state.expands.delete(key);
    } else {
      state.expands.add(key);
    }
    state.expands = new Set(state.expands);
  },
  SET_EXPAND_ALL(state) {
    console.log('setAll');
    const { isExpandAll, unDeptAssigneeVOS = [] } = state;
    const { deptVOS: deptList = [] } = state.assigneeResources;
    if (isExpandAll) {
      state.isExpandAll = false;
      state.expands = new Set();
      return;
    }
    const expands = new Set();
    deptList.forEach(item => {
      expands.add(`dept_${item.deptId}`);
      if (item?.assigneeVOS?.length) {
        item.assigneeVOS.forEach(
          assignee => {
            expands.add(`assignee_${item.deptId}_${assignee.assigneeId}`);
          }
        );
      }
    });
    // uid: `assignee_unDept_${assigneeId}`,
    if (unDeptAssigneeVOS.length > 0) {
      expands.add('dept_unDept');
      unDeptAssigneeVOS.forEach(
        assignee => {
          expands.add(`assignee_unDept_${assignee.assigneeId}`);
        }
      );
    }
    expands.add('unAssignee');
    state.isExpandAll = true;
    state.expands = expands;
  },
  SET_DEPT_EXPAND_ALL(state, { deptId, isExpandAll }) {
    console.log('dep');
    const { deptVOS: deptList = [] } = state.assigneeResources;
    const dept = deptList.find(item => item.deptId === deptId);
    if (!dept) {
      return;
    }
    if (!isExpandAll) {
      state.expands.add(`dept_${deptId}`);
    } else {
      state.expands.delete(`dept_${deptId}`);
    }
    dept.assigneeVOS.forEach(
      assignee => {
        if (!isExpandAll) {
          state.expands.add(`assignee_${deptId}_${assignee.assigneeId}`);
        } else {
          state.expands.delete(`assignee_${deptId}_${assignee.assigneeId}`);
        }

      }
    );
    state.expands = new Set(state.expands);
  },
  SET_OTHER_ASSIGNEE_EXPAND_FALSE(state, assigneeId) {
    // 收起所有的执行人除了自己
    [...state.expands].forEach(
      item => {
        if (item?.startsWith('assignee_') && item !== `assignee_${assigneeId}`) {
          state.expands.delete(item);
        }
      }
    );
    const { deptVOS: deptList = [] } = state.assigneeResources;
    // 展开所有的部门
    deptList.forEach(
      item => {
        state.expands.add(`dept_${item.deptId}`);
      }
    );
    state.expands.add('dept_unDept');
    state.expands.delete('unAssignee');
    if (assigneeId) {
      state.expands.delete('unAssignee');
    } else {
      state.expands.add('unAssignee');
    }
    state.expands = new Set(state.expands);
  },
  SET_VIEW_START_END(state, data) {
    state.startEndIndex = data;
  },
  UPDATE_ASSIGNEE_ISSUE(state, { issue }) {
    const assigneeId = issue?.assignee?.id;
    const key = assigneeId ? `assignee_${assigneeId}` : 'unAssignee';
    const flatList = state.assigneeIssue[key].flat();
    const index = flatList.findIndex(item => item.id === issue.id);
    flatList[index] = issue;
    const issues = newCalculateIssueList(flatList, state.issueMap, 'dept.assignee.issue', issue, assigneeId);

    state.assigneeIssue = {
      ...state.assigneeIssue,
      [key]: Object.freeze(issues)
    };
  },
  SET_DAY_CELL_WIDTH(state, dayCellWidth) {
    state.dayCellWidth = dayCellWidth;
  },
  SET_SELECT_TYPE(state, selectType) {
    state.selectType = selectType;
    const width = selectType === 'day' ? 160 : (selectType === 'week' ? 40 : 10);
    state.dayCellWidth = width;
  },
  SET_LIST(state, data) {
    // console.time();
    state.assigneeIssue = {};
    state.assigneeOriginIssue = {};
    const {
      deptVOS,
      unAssigneeIssueVOS
    } = data;

    const { unDeptAssigneeVOS = [] } = state;
    const list = [];
    // 部门
    deptVOS.forEach(
      ({ deptId, deptName, assigneeVOS, ...others }) => {
        list.push(
          Object.freeze({
            type: 'dept',
            id: deptId,
            isDept: true,
            name: deptName,
            key: `dept_${deptId}`,
            uid: `dept_${deptId}`,
            parentUid: null,
            path: 'dept',
            pathId: String(deptId),
            level: 0,
            height: 80,
            ...others
          })
        );
        if (assigneeVOS?.length) {
          for (let i = 0; i < assigneeVOS.length; i++) {
            let { assignee } = assigneeVOS[i];
            const { assigneeId, ...others } = assigneeVOS[i];
            assignee = assignee || { id: assigneeId, name: String(assigneeId) };
            const name = assignee.name;
            assignee.id = `${deptId}_${assigneeId}`;
            const key = `assignee_${deptId}_${assigneeId}`;
            list.push(Object.freeze({
              type: 'assignee',
              id: assigneeId,
              name,
              key,
              assignee,
              issueCount: others.issueVOS?.length,
              uid: `assignee_${deptId}_${assigneeId}`,
              assigneeId,
              parent: { id: deptId, name: deptName, key: `dept_${deptId}` },
              parentUid: `dept_${deptId}`,
              level: 1,
              isDept: true,
              path: 'dept.assignee',
              pathId: `${deptId}.${deptId}_${assigneeId}`,
              height: 80,
              ...others
            }));
            // 执行人下的事项
            if (others.issueVOS?.length) {
              // state.assigneeIssue[`assignee_${assigneeId}`] = Object.freeze(issues);
              state.assigneeOriginIssue[`assignee_${assigneeId}`] = {
                assigneeIdType: `assignee_${assigneeId}`,
                issueType: 'dept.assignee.issue',
                assigneeId: assigneeId,
                issueLength: others.issueVOS.length,
                issueVOS: others.issueVOS
              };
            }
          }
        }
      }
    );
    if (unDeptAssigneeVOS.length > 0) {
      let issueCount = 0;
      for (let i = 0; i < unDeptAssigneeVOS.length; i++) {
        const item = unDeptAssigneeVOS[i];
        issueCount += item.issueVOS.length;
      }
      list.push({
        type: 'dept',
        id: 'unDept',
        isDept: true,
        name: i18n.t('org.personnelMgr.group.noneGroup'),
        key: 'dept_unDept',
        uid: 'dept_unDept',
        parentUid: null,
        path: 'dept',
        pathId: 'unDept',
        level: 0,
        height: 80,
        issueCount,
        assigneeVOS: unDeptAssigneeVOS
      });
    }
    // 没有部门
    for (let i = 0; i < unDeptAssigneeVOS.length; i++) {
      let { assignee } = unDeptAssigneeVOS[i];
      const { assigneeId, ...others } = unDeptAssigneeVOS[i];
      assignee = assignee || { id: assigneeId, name: String(assigneeId) };
      const name = assignee.name;
      assignee.id = `unDept_${assigneeId}`;
      const key = `assignee_unDept_${assigneeId}`;
      list.push(Object.freeze({
        type: 'assignee',
        id: assigneeId,
        name,
        key,
        assignee,
        issueCount: others.issueVOS?.length,
        uid: `assignee_unDept_${assigneeId}`,
        assigneeId,
        parent: { id: 'unDept', name: i18n.t('org.personnelMgr.group.noneGroup'), key: 'dept_unDept' },
        parentUid: 'dept_unDept',
        level: 1,
        isDept: true,
        path: 'dept.assignee',
        pathId: `unDept.unDept_${assigneeId}`,
        height: 80,
        ...others
      }));
      // 执行人下的事项
      if (others.issueVOS?.length) {
        // const issues = newCalculateIssueList(others.issueVOS, state.issueMap, 'assignee.issue', null, assigneeId);
        // state.assigneeIssue[`assignee_${assigneeId}`] = Object.freeze(issues);
        state.assigneeOriginIssue[`assignee_${assigneeId}`] = {
          assigneeIdType: `assignee_${assigneeId}`,
          issueType: 'assignee.issue',
          assigneeId: assigneeId,
          issueLength: others.issueVOS.length,
          issueVOS: others.issueVOS
        };
      }
    }
    list.push(Object.freeze({
      type: 'unAssignee',
      name: i18n.t('project.nonAssignee'),
      issueCount: unAssigneeIssueVOS.length,
      id: -1,
      uid: 'unAssignee',
      level: 0,
      height: 80,
      path: 'unAssignee',
      pathId: 'unAssignee',
      issueVOS: unAssigneeIssueVOS
    }));
    // const issues = calcuteIssueList(unAssigneeIssueVOS, state.issueMap, 'unAssignee.issue');
    // const issues = newCalculateIssueList(unAssigneeIssueVOS, state.issueMap, 'unAssignee.issue', null, -1);
    // state.assigneeIssue.unAssignee = Object.freeze(issues);
    state.assigneeOriginIssue.unAssignee = {
      assigneeIdType: 'unAssignee',
      issueType: 'unAssignee.issue',
      assigneeId: -1,
      issueLength: unAssigneeIssueVOS.length,
      issueVOS: unAssigneeIssueVOS
    };
    // console.timeEnd();
    // console.log(999999999, '结束时间');
    // console.log(state.assigneeIssue);
    state.list = Object.freeze(list);
    // issueSortWebwork(state.assigneeOriginIssue, state.assigneeIssue, state.issueMap);
    // const issueDetailData = state.issueDetailData;
    // Object.values(state.assigneeIssue).forEach(item => {
    //   item.flat().forEach(ele => {
    //     if (issueDetailData[ele.id]) {
    //       Object.assign(ele, issueDetailData[ele.id]);
    //     }
    //   });
    // });
  },
  UPDATE_ASSIGNEE_RESOURCES(state, data) {
    const resourcesKeys = Object.keys(data);
    resourcesKeys.forEach(key => {
      state.assigneeResources[key] = data[key];
    });
    // 未分组
    state.unDeptAssigneeVOS = (data.unDeptAssigneeIds || []).map(item => data?.assigneeDetailMap[item]);
  }
};

const actions = {
  /**
   * 获取团队数据聚合接口
   * @param {*} param0
   * @param {*} params
   */
  async getAssigneeResources({ dispatch }, params) {
    const result = await getAssigneeResources(params) || {};
    dispatch('handleFormatResourcesData', { resourcesData: result });
    dispatch('handleCustomerHabitMap', result.customerHabitMap);
  },
  /**
   * 通过筛选条件查询团队数据
   * @param {*} param0
   * @param {*} resultData
   */
  async updateAssigneeResources({ state, dispatch, commit }, params = {}) {
    const result = await queryAssigneeResources(params) || {};
    dispatch('handleFormatResourcesData', { resourcesData: result, isRefresh: false });
    commit('SET_FILTER_VIEW', state.filter.view);
  },
  // 处理团队数据
  handleFormatResourcesData({ commit }, { resourcesData, isRefresh = true }) {
    const data = { ...resourcesData };
    data.deptVOS = data.deptVOS.map(item => {
      item.assigneeVOS = item.assigneeIds.map(ele => data?.assigneeDetailMap[ele]);
      return item;
    });
    isRefresh ? commit('SET_ASSIGNEE_RESOURCES', data) : commit('UPDATE_ASSIGNEE_RESOURCES', data);

    commit('SET_ORIGINDATALIST', data.headerDateVOS);
    commit('SET_DATE', data.headerDateVOS);
    commit('SET_ISSUE_MAP', {
      issueSprintMap: Object.freeze(data.issueSprintMap || {}),
      issueAssigneeMap: Object.freeze(data.issueAssigneeMap || {}),
      issueProjectMap: Object.freeze(data.issueProjectMap || {}),
      issueIssueTypeMap: Object.freeze(data.issueIssueTypeMap || {}),
      issueStateMap: Object.freeze(data.issueStateMap || {}),
      issueStateCategoryMap: Object.freeze(data.issueStateCategoryMap || {})
    });
    commit('SET_LIST', data);
    commit('SET_DRAG_TEAM_ISSUE_AREAID', '');
  },
  // 处理用户记录数据
  handleCustomerHabitMap({ commit }, customerHabitMap) {
    if (!customerHabitMap) {
      return;
    }
    let showWeekend = customerHabitMap?.resourcesManageWorkdaySwitch?.linkIdList[0];
    showWeekend = showWeekend ? eval(showWeekend) : true;
    commit('SET_SHOW_WEEKEND', showWeekend);

    let showStatus = customerHabitMap?.resourcesManageStatusColorSwitch?.linkIdList[0];
    showStatus = showStatus ? eval(showStatus) : true;
    commit('SET_SHOW_STATUSCOLOR', showStatus);

    let showMergeSubtask = customerHabitMap?.resourcesManageMergeSubtaskSwitch?.linkIdList[0];
    showMergeSubtask = showMergeSubtask ? eval(showMergeSubtask) : false;
    // console.log(99999, showMergeSubtask);
    commit('SET_SHOW_MERGESUBTASK', showMergeSubtask);
  },
  updateDateType({ commit, state }, selectType) {
    commit('SET_SELECT_TYPE', selectType);
    commit('SET_DATE', state.originHeaderDateVOS);
  },
  /**
   * 更新issue并且刷新聚合接口
   * @param {*} param0
   * @param {*} params
   */
  async updateIssueAndRefresh({ dispatch }, params) {
    if (!params.notUpdate) {
      await updateIssue(params);
    }
    dispatch('getAssigneeResources', {});
  },
  /**
   * 获取下拉列表选项
   * @param {*} param0
   * @param {*} param1
   * @returns
   */
  async getIssueSelectOptions({ commit }, { projectId, issueTypeId }) {
    const key = `projectId_${projectId}_issueTypeId_${issueTypeId}`;
    if (state.selectOption[key]) {
      return;
    }
    const data = await getIssueSelectOptions({ projectId, issueTypeId });
    if (!data?.length) {
      return;
    }
    commit('SET_SELECT_OPTIONS', { [key]: data });
  }
};


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
function getDiffDays(start, end) {
  if (!(start && end)) {
    return;
  }
  const startDate = dayjs(start).format('YYYY-MM-DD');
  const endDate = dayjs(end).format('YYYY-MM-DD');
  return dayjs(endDate).diff(startDate, 'day', true);
}
function getStartOrEndWeekend(list, isEnd) {
  let days = 0;
  if (isEnd) {
    for (let i = list.length - 1; i >= 0; i--) {
      if (list[i].workday) {
        break;
      }
      days++;
    }
    return days;
  }

  for (let i = 0; i < list.length; i++) {
    if (list[i].workday) {
      break;
    }
    days++;
  }
  return days;
}
function addItem(num, list, startDate, endDate, dayCellWidth, isCloseWeekend = false, startWeekendDays = 0, endWeekendDays = 0) {
  for (let i = 1; i <= num; i++) {
    if (startDate) {
      if (!(isCloseWeekend && startWeekendDays >= i)) {
        const subtractDate = dayjs(startDate).subtract(i, 'day');
        if (!(isCloseWeekend && (dayjs(subtractDate).day() === 0 || dayjs(subtractDate).day() === 6))) {
          list.unshift(Object.freeze({
            date: subtractDate.format('YYYY-MM-DD'),
            noStatistics: true,
            width: dayCellWidth
          }));
        }
      }
    }
    if (endDate) {
      if (!(isCloseWeekend && endWeekendDays >= i)) {
        const abstractDate = dayjs(endDate).add(i, 'day');
        if (!(isCloseWeekend && (dayjs(abstractDate).day() === 0 || dayjs(abstractDate).day() === 6))) {
          list.push(Object.freeze({
            date: abstractDate.format('YYYY-MM-DD'),
            noStatistics: true,
            width: dayCellWidth
          }));
        }
      }
    }
  }
  return list;
}
function calDiffDays(dateList, dayCellWidth, isCloseWeekend = false) {
  const firstDate = dayjs(dateList[0].date), lastDate = dayjs(dateList[dateList.length - 1].date), today = dayjs(new Date());
  let totalDiff = 0;
  if (today.isBefore(firstDate, 'day')) {
    totalDiff = getDiffDays(today, firstDate);
  }
  if (today.isAfter(lastDate, 'day')) {
    totalDiff = getDiffDays(lastDate, today);
  }
  if (!totalDiff) {
    return;
  }
  totalDiff += 60;
  addItem(totalDiff, dateList, firstDate, lastDate, dayCellWidth, isCloseWeekend);
}
function addItemByMonth(num, list, startDate, endDate, dayCellWidth) {
  const nextEndDay = dayjs(endDate).add(1, 'day');
  for (let i = 1; i <= num; i++) {
    const startTotalDays = dayjs(startDate).subtract(i, 'month').daysInMonth();
    const endTotalDays = dayjs(nextEndDay).add(i - 1, 'month').daysInMonth();
    addItem(startTotalDays, list, list[0].date, false, dayCellWidth);
    addItem(endTotalDays, list, false, list[list.length - 1].date, dayCellWidth);
  }
}
function createDateItem(item) {
  const date = item.date;
  const month = dayjs(date).month() + 1;
  const year = dayjs(date).year();
  const week = dayjs(date).week();
  let weekYear = year;
  // 周跨年时候处理
  if (month === 1 && week > 10) {
    weekYear--;
  }
  if (month === 11 && week === 1) {
    weekYear++;
  }
  return Object.freeze({
    month,
    year,
    week,
    year_month: `${year}_${month}`,
    year_week: `${weekYear}_${week}`,
    ...item
  });
}
function isOverflow(start1, end1, start2, end2) {
  // return !(dayjs(start1).isAfter(end2, 'day') || dayjs(end1).isBefore(start2, 'day'));
  // console.log(55555, start1, end1, start2, end2);
  // start1 = new Date(start1).setHours(0, 0, 0, 0);
  // end1 = new Date(end1).setHours(0, 0, 0, 0);
  // start2 = new Date(start2).setHours(0, 0, 0, 0);
  // end2 = new Date(end2).setHours(0, 0, 0, 0);
  return (start1 > end2 || end1 < start2);
}

// function calcuteIssueList(issueList, issueMap, path, currentIssue) {
//   // console.log(999999, issueList);
//   if (!Array.isArray(issueList)) {
//     return;
//   }
//   const newList = [];
//   if (currentIssue){
//     for (let i = 0; i <= currentIssue.line; i++) {
//       newList[i] = [];
//     }
//     newList[currentIssue.line].push(currentIssue);
//   }
//   issueList.forEach(issueItem => {
//     if (currentIssue?.id === issueItem.id){
//       return;
//     }
//     const { calcStartDate, calcDueDate } = issueItem;
//     const index = newList.findIndex(item => item?.every(subitem => {
//       return !isOverflow(
//         calcStartDate,
//         calcDueDate,
//         subitem.calcStartDate,
//         subitem.calcDueDate
//       );
//     }));
//     const formatIssueItem = {
//       ...issueItem,
//       type: 'issue',
//       project: issueMap?.issueProjectMap?.[issueItem.projectId] || {},
//       sprint: issueMap?.issueSprintMap?.[issueItem.sprintId] || {},
//       assignee: issueMap?.issueAssigneeMap?.[issueItem.assigneeId] || {},
//       issueType: issueMap?.issueIssueTypeMap?.[issueItem.issueTypeId] || {},
//       parentIssueType: issueMap?.issueIssueTypeMap?.[issueItem.parentIssueTypeId] || {},
//       state: issueMap?.issueStateMap?.[issueItem.stateId] || {},
//       stateCategoryVO: issueMap?.issueStateCategoryMap?.[issueItem.stateCategory] || {},
//       uid: `issue_${issueItem.id}`,
//       parentUid: `assignee_${issueItem.assigneeId}`,
//       path,
//       height: 50
//     };
//     if (index === -1) {
//       newList[newList.length] = [{ ...formatIssueItem, line: newList.length }];
//     } else {
//       newList[index].push({ ...formatIssueItem, line: index });
//     }
//   });
//   // console.log(8888888, issueList);
//   return newList;
// }


export function newCalculateIssueList(issueList, issueMap, path, currentIssue, assigneeId) {
  console.time();
  if (!Array.isArray(issueList)) {
    return;
  }
  const newList = [];
  if (currentIssue) {
    for (let i = 0; i <= currentIssue.line; i++) {
      newList[i] = [];
    }
    newList[currentIssue.line].push(currentIssue);
  }

  const hasMultiSubtaskIssues = Object.entries(groupBy(issueList, 'pid')).filter(entry => entry[0] !== 'null' && entry[1].length > 1);
  // console.log('🚀 ~ file: resource.js:792 ~ calcuteIssueList ~ grouped', hasMultiSubtaskIssues);

  const virtualAreas = [];

  const formatIssue = (issueItem) => ({
    ...issueItem,
    type: 'issue',
    project: issueMap?.issueProjectMap?.[issueItem.projectId] || {},
    sprint: issueMap?.issueSprintMap?.[issueItem.sprintId] || {},
    assignee: issueMap?.issueAssigneeMap?.[issueItem.assigneeId] || {},
    issueType: issueMap?.issueIssueTypeMap?.[issueItem.issueTypeId] || {},
    parentIssueType: issueMap?.issueIssueTypeMap?.[issueItem.parentIssueTypeId] || {},
    state: issueMap?.issueStateMap?.[issueItem.stateId] || {},
    stateCategoryVO: issueMap?.issueStateCategoryMap?.[issueItem.stateCategory] || {},
    uid: `issue_${issueItem.id}`,
    parentUid: `assignee_${issueItem.assigneeId}`,
    path,
    height: 50
  });

  const placeToRows = (list, isMerge, calcStartDate, calcDueDate, listIndex = 0) => {
    let virtualArea = {
      rowStart: null,
      rowEnd: null
    };
    const addAreaArr = [];
    const idObj = [];
    let isSetMerge = true;
    let lastRow = 0;
    // 将时间搓拍平当天；
    list.forEach(item => {
      item.calcStartDate = new Date(item.calcStartDate).setHours(0, 0, 0, 0);
      item.calcDueDate = new Date(item.calcDueDate).setHours(0, 0, 0, 0);
    });

    for (let idx = 0; idx < list.length; idx++) {
      const issueItem = list[idx];
      if (currentIssue?.id === issueItem.id) {
        if (isMerge) {
          addAreaArr.push(issueItem);
          lastRow = issueItem.line;
        }
        return;
      }
      if (!isMerge) {
        calcStartDate = issueItem.calcStartDate;
        calcDueDate = issueItem.calcDueDate;
      }
      const index = newList.findIndex((row, index) => {
        if (index >= listIndex) {
          return ([...row || [], ...virtualAreas[index] || []])?.every(subItem => {
            if (subItem.areaId) {
              return true;
            }
            if (isMerge && idObj[subItem.id]) {
              return isOverflow(
                issueItem.calcStartDate,
                issueItem.calcDueDate,
                subItem.calcStartDate,
                subItem.calcDueDate
              );
            }
            return isOverflow(
              calcStartDate,
              calcDueDate,
              subItem.calcStartDate,
              subItem.calcDueDate
            );
          });
        }
        return false;
      });
      const formatIssueItem = formatIssue(issueItem);
      // if (virtualArea.length === 0) {
      //   virtualArea[0] = [{ ...formatIssueItem, line: 0 }];
      // }
      if (isMerge) {
        idObj[issueItem.id] = true;
      }
      const row = index === -1 ? newList.length : index;
      if (isMerge) {
        if (idx !== 0) {
          // 判断合并子任务是否排序一起，中间是否有其他issue, 如果有进行回撤；
          if (row - lastRow > 1) {
            // console.log(9999999, lastRow, row);
            addAreaArr.forEach(item => {
              if (newList[item.line]) {
                newList[item.line].pop();
                if (newList[item.line].length === 0) {
                  newList.splice(item.line, newList.length - item.line + 2);
                }
              }
            });
            isSetMerge = false;
            virtualArea = placeToRows(list, isMerge, calcStartDate, calcDueDate, row);
            break;
          }
        }
        lastRow = row;
        listIndex = row;
      }
      if (!newList[row]) {
        newList[row] = [];
      }
      const newListItem = { ...formatIssueItem, line: row };
      newList[row].push(newListItem);
      addAreaArr.push(newListItem);
      if (virtualArea.rowStart === null) {
        virtualArea.rowStart = row;
      } else if (virtualArea.rowStart > row) {
        virtualArea.rowStart = row;
      }

      if (virtualArea.rowEnd === null) {
        virtualArea.rowEnd = row;
      } else if (virtualArea.rowEnd < row) {
        virtualArea.rowEnd = row;
      }

      // if (virtualArea.startDate === null) {
      //   virtualArea.startDate = calcStartDate;
      // } else if (virtualArea.startDate > calcStartDate) {
      //   virtualArea.startDate = calcStartDate;
      // }

      // if (virtualArea.endDate === null) {
      //   virtualArea.endDate = calcDueDate;
      // } else if (virtualArea.endDate < calcDueDate) {
      //   virtualArea.endDate = calcDueDate;
      // }
    }

    if (isMerge && isSetMerge) {
      const mergeItem = maxBy(addAreaArr.filter(item => item.line === virtualArea.rowStart), 'calcStartDate');
      // console.log(777777, mergeItem, virtualArea);
      mergeItem.areaStartDate = calcStartDate;
      mergeItem.areaEndDate = calcDueDate;
      mergeItem.rowStart = virtualArea.rowStart;
      mergeItem.rowEnd = virtualArea.rowEnd;
      mergeItem.isMerge = isMerge;
      assigneeId = assigneeId ? assigneeId : -1;
      addAreaArr.forEach(item => {
        item.areaId = `area_${assigneeId}_${mergeItem.pid}`;
      });
      // 18221524
      // 28030388
      // if (mergeItem.id === 4085179) {
      //   console.log(99333333, mergeItem, addAreaArr, newList);
      // }
      // console.log(99333333, firstItem, addAreaArr, newList);
      //
    }
    return virtualArea;
  };

  let placedIssues = [];
  hasMultiSubtaskIssues.forEach(([pid, subtaskIssues]) => {
    placedIssues = [...placedIssues, ...subtaskIssues.map(issueItem => issueItem.id)];
    const minStartDateItem = minBy(subtaskIssues, 'calcStartDate');
    const maxEndDateItem = maxBy(subtaskIssues, 'calcDueDate');
    // console.log(99999666, minStartDateItem.calcStartDate, maxEndDateItem.calcDueDate);
    const area = placeToRows(subtaskIssues, true, minStartDateItem.calcStartDate, maxEndDateItem.calcDueDate);
    // console.log(66663333, area);
    if (area) {
      range(area.rowStart, area.rowEnd + 1).forEach(row => {
        if (virtualAreas[row] === undefined) {
          virtualAreas[row] = [];
        }
        virtualAreas[row].push({
          id: `virtual_${pid}`,
          pid,
          calcDueDate: maxEndDateItem.calcDueDate,
          calcStartDate: minStartDateItem.calcStartDate
        });
      });
    }
  });

  placeToRows(issueList.filter(issueItem => !placedIssues.includes(issueItem.id)));
  // console.log('🚀 ~ file: resource.js:1090 ~ range ~ virtualAreas', virtualAreas, newList);
  console.log('9999996666', 'virtualArea');
  console.timeEnd();
  return newList;
}

// function issueSortWebwork(assigneeOriginIssue, assigneeIssue, issueMap) {
//   const myWorker = new Worker('/issueSortWebwork.js');
//   myWorker.addEventListener('message', e => {
//     console.log(88888888, e);
//     assigneeIssue[e.data.assigneeIdType] = e.data.issueVOS;
//   });
//   console.log(6663333, myWorker);
//   myWorker.postMessage({ assigneeOriginIssue, assigneeIssue, issueMap });
// }
